import { render, staticRenderFns } from "./SlideSearch.vue?vue&type=template&id=68ff7602&"
import script from "./SlideSearch.vue?vue&type=script&lang=js&"
export * from "./SlideSearch.vue?vue&type=script&lang=js&"
import style0 from "./SlideSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports